import { useQuery } from '@tanstack/react-query';

import { DocumentParams } from '../../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../../logic/unwrapNonPaginatedResponseDataAs';
import { FILTERS_BASE_PATH } from '../../constants/filtersBasePath';
import { getFilters } from '../../requests/getFilters';

export const useFilters = (params?: DocumentParams) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getFilters>>
  >({
    queryKey: [FILTERS_BASE_PATH, params],
    queryFn: () => getFilters(constructGet, params),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    staleTime: 10000,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'filters'),
    ...rest,
  };
};
